import type { ReactNode } from 'react';

export const symbol_notifications_paused: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M190-200q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h50v-304q0-84 49.5-150.5T420-798v-22q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v22q81 17 130.5 83.5T720-564v304h50q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H190Zm290-302Zm0 422q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM300-260h360v-304q0-75-52.5-127.5T480-744q-75 0-127.5 52.5T300-564v304Zm255-80q11 0 19.5-8.03t8.5-19.5q0-11.47-8.5-19.97Q566-396 555-396h-96l118-151q3-3.91 4.5-8.61 1.5-4.69 1.5-9.39v-18q0-11-8.5-19.5T555-611H406q-11 0-19.5 8.03t-8.5 19.5q0 11.47 8.5 19.97Q395-555 406-555h95L384-404q-3 3.91-4.5 8.61-1.5 4.69-1.5 9.39v18q0 11 8.5 19.5T406-340h149Z"
		/>
	</svg>
);
